import api from 'services/api';
import { IntegrationPreferenceProps } from './integration-preference-service';

export type IntegrationProps = {
  uuid?: string;
  name?: string;
  preferences?: IntegrationPreferenceProps[] | any;
};

const findAllIntegrations = async () => {
  const response = await api.get<IntegrationProps[]>('/apiv1/integrations/');
  return response?.data;
};

const findIntegrationById = async (uuid: string | undefined) => {
  const response = await api.get<IntegrationProps>(`/apiv1/integration/${uuid}/`);
  return response?.data;
};

const createIntegration = async (newIntegration: IntegrationProps) => {
  const response = await api.post<IntegrationProps>('/apiv1/integration/', newIntegration);
  return response?.data;
};

const updateIntegration = async (
  uuid: string | undefined,
  updatedIntegration: IntegrationProps
) => {
  const response = await api.put<IntegrationProps>(
    `/apiv1/integration/${uuid}/`,
    updatedIntegration
  );
  return response?.data;
};

const deleteIntegrationById = async (uuid: string | undefined) => {
  const response = await api.delete<IntegrationProps>(`/apiv1/integration/${uuid}/`);
  return response?.data;
};

const IntegrationService = {
  findAllIntegrations,
  findIntegrationById,
  createIntegration,
  updateIntegration,
  deleteIntegrationById
};

export default IntegrationService;
